import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {isEmpty} from 'lodash';
import {setLanguage} from '../../util/uiconstants';
import {labels} from '../../util/uiconstants';
import MotifNav from '@ey/canvascoreservices/MotifNav';

const Nav = (props) => {
	const user = useSelector((store) => store.user);
	const meInfo = useSelector((store) => store.userPermissions);

	useEffect(() => {
		setLanguage('en-us');
	}, [user]);

	let validUser = false;
	if (user && user.hasOwnProperty('id') && !isEmpty(user.id)) {
		validUser = true;
	}

	return (
		<StyledServerMotifNav className="server-nav">
			<MotifNav
				applicationName={labels.adminTool}
				applicationNameRedirectUrl="/admin"
				copyrightMessage={labels.copyrightMessage}
				showMoreMenuOptions={false}
				showSelectorDropdown={false}
				showIconLinks={false}
				showNotifications={false}
				showSettings={false}
				showAvatar={true}
				showSearchBox={false}
				avatarProps={meInfo?.userInitials && {userName:`${meInfo.userInitials[0]} ${meInfo.userInitials[1]}`}}
			>
			</MotifNav>
		</StyledServerMotifNav>
	);
};

export default Nav;

const StyledServerMotifNav = styled.section`
	.motif-header {
		display: flex;
		background: #f9f9fe;
		color: #2e2e38;
		padding: 0.4285714286rem 0.7142857143rem;
		z-index: 100;
		height: 4rem;
		border-radius: 0;
		border-bottom: 0.0625rem solid #e6e6e9;
		justify-content: space-between;
		align-items: center;
		min-width: max-content;
		max-width: 100%;
		gap: 0.5714285714rem;
	}
`;